import React, { Component } from "react";
import { ModalHelp } from "./ModelHelp";
import TriggerButton from "./TreggerHelp";
import { Button, Box, Typography } from "@mui/material";
export class ContainerHelp extends Component {
  state = { isShown: false };
  showModal = () => {
  
    this.setState({ isShown: true }, () => {
      this.closeButton.focus();
    });
    this.toggleScrollLock();
  };
  closeModal = () => {
    this.setState({ isShown: false });
    this.TriggerButton.focus();
    this.toggleScrollLock();
  };
  onKeyDown = (event) => {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  };
  onClickOutside = (event) => {
    if (this.modal && this.modal.contains(event.target)) return;
    this.closeModal();
  };

  toggleScrollLock = () => {
    document.querySelector("html").classList.toggle("scroll-lock");
  };

  render() {
    return (
      <React.Fragment>
        <TriggerButton
          showModal={this.showModal}
          variant="contained"
          color="primary"
          buttonRef={(n) => (this.TriggerButton = n)}
          triggerText={this.props.triggerText}
        />
        {this.state.isShown ? (
          <ModalHelp
            
            onClick={this.props.onClick}
            id={this.props.id}
            modalRef={(n) => (this.modal = n)}
            buttonRef={(n) => (this.closeButton = n)}
            closeModal={this.closeModal}
            onKeyDown={this.onKeyDown}
            onClickOutside={this.onClickOutside}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default ContainerHelp;
